import styled from "styled-components"

const Row = styled.div`
  display: grid;
  row-gap: 10px;
`

export default Row
